import React, { useContext, useEffect } from 'react';
import { Context as CountriesContext } from './context/CountriesContext';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Paper } from '@material-ui/core';
import Navbar from './components/Navbar';
import StatsBox from './components/StatsBox';
import Table from './components/Table';
import LineGraph from './components/LineGraph';
import DoughnutGraph from './components/DoughnutGraph';
import CountryMenu from './components/CountryMenu';
import Map from './components/Map';
import News from './components/News';
import DonationInfo from './components/DonationInfo';
import { findCountry } from './utils';
import Health from './components/Health';
import './styles/App.css';

function App() {
  const { state, fetchCountries } = useContext(CountriesContext);

  useEffect(() => {
    fetchCountries();
  }, []);

  if (state.countries.length < 1) return null;

  const country = findCountry(state.countries, state.selectedCountry);

  return (
    <div className="app">
      <Router basename="/">
        <Navbar title="Covid-19 Tracker" />
        <Switch>
          <Route exact path="/">
            <Main country={country} />
          </Route>
          <Route exact path="/donations">
            <DonationInfo />
          </Route>
          <Route exact path="/safety">
            <Health />
          </Route>
        </Switch>
      </Router>
    </div>
  );
}
function Main({ country }) {
  return (
    <>
      <section id="app__main">
        <section className="main__left">
          <Table />
        </section>
        <section className="main__right">
          <Paper className="main__header">
            <h3 className="header__title">{country.country}</h3>
            <CountryMenu />
          </Paper>
          <section id="main__dashboard">
            <section className="stats">
              <StatsBox title="Infected" statType="cases" />
              <StatsBox title="Recovered" statType="recovered" />
              <StatsBox title="Deaths" statType="deaths" />
            </section>
            <Map />
          </section>
          <section id="graphs">
            <DoughnutGraph />
            <LineGraph />
          </section>
        </section>
      </section>

      <News />
    </>
  );
}

export default App;
